export default __webpack_public_path__ + "static/media/IMG_4598.3bd70fe0.jpeg";